import React, { useEffect } from 'react';

import classNames from 'classnames';

import NumberFormat from 'CommonComponents/LocalisedNumberFormat';

const cx = classNames.bind({
    white: 'tw-bg-white hover:tw-bg-charcoal-25 tw-text-charcoal placeholder:tw-text-charcoal-75',
    default: 'tw-bg-charcoal-75 hover:tw-bg-charcoal-50 tw-text-charcoal placeholder:tw-text-charcoal-75',
});

function FloatInput({ containerClasses = '', ...props }) {
    var currentValue = props.value;
    const handleChange = (value) => {
        var newValue = value.floatValue !== undefined ? value.floatValue : 0;
        props.handleQuantityChange(newValue, props.expenseKey, props.venueId, props.quantityName, props.price);
    };
    const handleFocus = (event) => event.target.select();
    useEffect(() => {
        props.handleQuantityChange(currentValue || 0, props.expenseKey, props.venueId, props.quantityName, props.price);
    }, []);
    return (
        <div className={`tw-relative ${containerClasses}`}>
            {props.prefix && (
                <div className="tw-absolute tw-inset-y-0 tw-start-0 tw-flex tw-items-center tw-ps-1.5 tw-text-xs tw-text-charcoal-75">{props.prefix}</div>
            )}
            <NumberFormat
                value={currentValue}
                defaultValue={0}
                className={cx(
                    'tw-block tw-h-7 tw-w-full tw-rounded-lg tw-text-xs tw-px-2 tw-py-1 tw-border-0 tw-font-semibold placeholder:tw-text-xs placeholder:tw-font-normal',
                    {
                        'tw-pl-5': props.prefix,
                        'tw-pr-5': props.suffix,
                        white: props.variant === 'white' && !props.isLinked,
                        default: !['white'].includes(props.variant) && !props.isLinked,
                        '!tw-bg-blue-15 !tw-border !tw-border-blue': props.isLinked,
                    },
                )}
                decimalScale={2}
                thousandSeparator={true}
                inputMode="numeric"
                allowNegative={false}
                disabled={props.disabled}
                onValueChange={handleChange}
                onFocus={handleFocus}
            />
            {props.suffix && (
                <div className="tw-absolute tw-inset-y-0 tw-end-0 tw-flex tw-items-center tw-pe-1.5 tw-text-xs tw-text-charcoal-75">{props.suffix}</div>
            )}
        </div>
    );
}

export default React.memo(FloatInput);
